/**
 * @method diff
 * @since 1.0.0
 */
export function diff(values, versus) {
    const insert = {};
    const remove = {};
    const update = {};
    Object.assign(remove, values);
    for (const key in versus) {
        const child = versus[key];
        if (values[key] == null) {
            insert[key] = child;
        }
        else {
            update[key] = child;
        }
        delete remove[key];
    }
    return [insert, remove, update];
}
